<template>
  <div role="dialog" class="popup fadein absolute z-50 flex justify-center items-center">
    <div class="popup-wrapper z-50 w-1/2 xl:w-1/3 max-w-lg h-auto flex flex-row-reverse rounded-xl bg-slate-middle">
      <div
        tabindex="0"
        ref="firstFocus"
        class="absolute h-6 w-6 mr-2 mt-3 p-1.5 bg-black rounded-full flex justify-center items-center cursor-pointer"
        @keydown.enter="close()"
        @pointerdown.stop="close()"
      >
        <img class="w-5 h-5 invert rotate-45" :src="Close" />
      </div>
      <div class="flex flex-col items-start w-full h-full p-9 font-middle overflow-x-hidden">
        <h2 class="ml-1 mb-4 text-slate-white text-2xl font-bold">{{ t('exportheadline') }}</h2>
        <h2 class="ml-1 mb-4 text-slate-white text-lg">{{ t('fileexport') }}</h2>
        <input ref="fileName" v-model="state.fileName" class="text-xl font-bold w-full bg-slate-dark p-4 rounded-lg text-slate-white" type="text" />
        <!-- <p class="text-slate-white font-bold text-xl mt-5 mb-2">{{ t('exportfilter') }}</p> -->
        <!-- <div
         class="text-left text-xl font-bold bg-slate-dark p-4 rounded-lg text-slate-white my-2 capitalize flex w-full justify-between"
          @click="toggleFilterDropdown()"
          @touchstart.prevent="toggleFilterDropdown()"
        >
          <p class="">
            {{ t(`${state.selectedFilter}`) }}
           </p>
          <img class="relative -rotate-90 w-3 -ml-9 mr-2 cursor-pointer invert z-51" :src="Arrow" />
        </div> -->
        <!-- <div
          v-if="state.filterDropdownIsVisible"
          class="bg-slate-dark -mt-6 mb-2 p-3 w-full rounded-b-lg max-h-56 overflow-y-scroll overflow-x-hidden"
        >
          <div
            v-for="(filter, index) in availableFilters()"
            :key="index"
            class="flex justify-between items-center cursor-pointer text-left py-px my-2 mb-4"
          >
            <p
              class="text-md text-slate-white font-bold ml-1 cursor-pointer capitalize"
              @click="selectFilter(filter)"
              @touchstart.prevent="selectFilter(filter)"
            >
             {{ filter }}
            </p>
          </div>
        </div> -->
        <div v-if="state.requestSent" class="w-full flex justify-center py-7">
          <Loader />
        </div>
        <div class="flex w-full flex-col mb-3">
          <Notice v-if="state.fileUrl.length > 0" :type="DialogMessageType.Success" :text="t('downloadready')" class="w-full mb-5" />
          <!--div v-if="state.fileUrl.length > 0" class="bg-blue-middle rounded-3xl text-white font-bold p-3 px-6 flex self-center">
            <a @click="download(state.fileName, state.fileUrl)">{{ t('download') }}</a>
          </div-->
        </div>
        <div class="flex w-full">
          <div class="pt-5 flex justify-between items-center w-full">
            <button @click="close()" class="gray-btn cursor-pointer p-3 px-5 text-md font-medium text-slate-white mr-2 capitalize">
              {{ t('cancel') }}
            </button>
            <button class="blue-btn cursor-pointer p-3 px-5 text-md font-medium text-slate-white capitalize" @click="sendWallExportRequest()">
              {{ t('export') }}
            </button>
            <!--div
              @click="download(state.fileName, state.fileUrl)"
              class="blue-btn cursor-pointer p-3 px-5 text-md font-medium text-slate-white capitalize"
            >
              Downlaod
            </div-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { reactive, ref, onMounted, computed, nextTick } from 'vue'
  import { useI18n } from 'vue-i18n'

  import { FilterType } from '@/constants'
  import { ExportResponse } from '@/common/interfaces'
  import { DialogMessageType } from '@/common/classes'

  import useWallStore from '@/composables/wallStore'
  import useCommonStore from '@/composables/common'

  import Notice from '@/components/dialog/Notice.vue'
  import Loader from '@/components/common/Loader.vue'

  import Close from '../../assets/icons/fontawesome/plus-solid.svg'
  import Arrow from '../../assets/icons/fontawesome/angle-left-solid.svg'
  import { useNoteStore } from '@/composables/noteStore'

  const messages = {
    no: {
      filename: 'nytt-fil-navn',
      boardexists: 'En tavle med dette navnet finnes allerede',
      fileexport: 'Filnavn',
      export: 'Eksport',
      downloadready: 'Ditt dokument er klar for nedlasting!',
      exportfilter: 'Organiser bidrag etter',
      exportheadline: 'Eksporter tavla som Word dokument',
      exportnotpossible: 'Kan ikke eksportere en tavle uten innhold',
    },
    en: {
      filename: 'new-file-name',
      boardexists: 'A wall with the same name already exists',
      fileexport: 'File name',
      export: 'Export',
      downloadready: 'Your document is ready to be downloaded!',
      exportfilter: 'Group contributions by',
      exportheadline: 'Export wall as Word document',
      exportnotpossible: "Can't export a wall without content",
    },
  }

  const common = useCommonStore()
  const noteStore = useNoteStore()
  const wallStore = useWallStore()

  const { t } = useI18n({ messages })

  const fileName = ref<HTMLInputElement | null>(null)

  const emit = defineEmits<{
    (e: 'closePopup'): void
  }>()

  const props = defineProps({
    wallId: { type: String, required: true },
  })

  const state = reactive({
    fileName: wallStore.getters.selectedWall.value?.details.title || `${t('filename')}`,
    selectedFilter: FilterType.TIME,
    fileUrl: '',

    filterDropdownIsVisible: false,
    requestSent: false,
  })
  const firstFocus = ref()

  onMounted(() => {
    nextTick(() => firstFocus.value?.focus())
  })

  function availableFilters() {
    return [FilterType.TIME, FilterType.BOARDS, FilterType.USERS]
  }

  async function sendWallExportRequest() {
    state.requestSent = true
    await wallStore.actions.wallExport(props.wallId, state.fileName, state.selectedFilter, common.getters.languageCode.value)
    //if (res.success) state.fileUrl = (res.body as ExportResponse).url
    state.requestSent = false

    //Close export dialoge after exporting...
    close()
  }

  function selectFilter(filter: FilterType) {
    state.selectedFilter = filter
    toggleFilterDropdown()
  }

  function toggleFilterDropdown() {
    state.filterDropdownIsVisible = !state.filterDropdownIsVisible
  }

  function close() {
    emit('closePopup')
  }

  /*   function download(fileName: string, fileUrl: string) {
    const link = document.createElement('a')
    link.href = `/wall/${wallId}/export`
    link.download = fileName
    link.click()
  } */
</script>

<style scoped></style>
